module.exports = __webpack_public_path__ + "static/img/warning.4aa96f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warning.png
// module id = Ufxh
// module chunks = 1